import { render } from "./FlatCard.vue?vue&type=template&id=25aa3c05&scoped=true"
import script from "./FlatCard.vue?vue&type=script&lang=js"
export * from "./FlatCard.vue?vue&type=script&lang=js"

import "./FlatCard.vue?vue&type=style&index=0&id=25aa3c05&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25aa3c05"]])

export default __exports__